<div class="mask rgba-stylish-strong flex-center">
  <div class="container white-text">
    <ng-content></ng-content>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/intro/intro.component.html